// path dos banners na pasta "public"
export const images = {
  ceo: './assets/images/ceo.jpg',
  dimension: './assets/images/dimension.jpg',
  novaAmerica: './assets/images/nova-america.jpg',
  uruguaiana: './assets/images/uruguaiana.jpg'
}
